<mat-expansion-panel #addressesPanel class="checkout-expansion-panel" [disabled]="disabled">
  <mat-expansion-panel-header collapsedHeight="4.25rem" expandedHeight="4.25rem">
    <mat-panel-title>
      <ng-container *ngIf="deliveryMethod === 'delivery'; else takeAway">
        <address *ngIf="address" [address]="address" class="checkout-address"></address>
      </ng-container>
      <ng-template #takeAway>
        <div class="takeaway-wrapper">
          <svg
            class="delivery-method-image"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 12 19"
          >
            <defs>
              <path id="a" d="M0 0h24v24H0z" />
            </defs>
            <g fill="none" fill-rule="evenodd" transform="translate(-6 -2.5)">
              <mask id="b" fill="#fff">
                <use xlink:href="#a" />
              </mask>
              <g fill-rule="nonzero" mask="url(#b)">
                <path
                  d="M13.818 4.169c.243.56.196 1.217-.154 1.728a1.842 1.842 0 0 1-1.587.777 1.982 1.982 0 0 1-1.543-.86 1.827 1.827 0 0 1-.174-1.75 1.809 1.809 0 0 1 1.406-1.046 1.98 1.98 0 0 1 1.666.576c.163.168.294.364.386.575ZM17.337 9.978l-.771-.069-1.316-.117-.396-.036c-.008 0-.046.001-.051-.004l-.034-.038-.565-.646-.87-.99-.65-.744c-.063-.071-.124-.144-.197-.206a1.094 1.094 0 0 0-.77-.254c-.044.002-.089.01-.133.012-.051.001-.103 0-.154.002a1.12 1.12 0 0 0-.29.05c-.1.03-.186.078-.276.126-.079.042-.145.097-.22.144l-.203.132-.918.593-1.126.726-.761.491c-.07.045-.142.087-.205.138a.811.811 0 0 0-.242.367l-.3.812-.45 1.216c-.114.312-.23.623-.345.935l-.055.149a.678.678 0 0 0 .27.792.774.774 0 0 0 .88-.025.8.8 0 0 0 .246-.34l.362-.836.513-1.186.315-.727c.005-.012.005-.018.017-.024l.124-.06.528-.26.578-.282.185-.091a.442.442 0 0 0 .083-.049c.206-.16.404-.332.605-.5-.002.032-.022.064-.038.092a1.68 1.68 0 0 1-.091.142 4.327 4.327 0 0 1-.483.566c-.015.015-.01.036-.009.057v.083c.002.206 0 .412-.007.618-.012.369-.04.737-.087 1.104-.041.323-.094.646-.138.97a16.6 16.6 0 0 0-.067.58c-.003.024-.011.046.007.064l-.001.007-.004.028-.044.302-.167 1.156-.17 1.17-.046.318a.192.192 0 0 1-.024.077l-.353.65-.603 1.108-.584 1.074-.295.541a.731.731 0 0 0-.005.697.823.823 0 0 0 .793.414.825.825 0 0 0 .595-.335l.116-.16.57-.784.773-1.065.682-.939.295-.406c.088-.121.116-.263.15-.404.037-.143.072-.286.108-.43l.3-1.197.074-.294c.022-.088.036-.18.053-.27l.08-.445.006-.027c.02.026.025.064.031.095.011.055.018.112.023.169a4.09 4.09 0 0 1 .008.648c-.002.02-.016.054-.002.072l.077.096.75.935.267.334c.023.029.029.052.04.087.075.249.151.497.228.746l.368 1.203.356 1.167.195.634c.057.19.178.352.358.457a.852.852 0 0 0 .906-.041.747.747 0 0 0 .31-.729l-.024-.142-.147-.862-.214-1.254-.204-1.197-.117-.689-.007-.04a.913.913 0 0 0-.159-.347l-.084-.128-.536-.816-.723-1.098-.525-.798-.056-.085-.012-.019c-.009-.013.006-.049.009-.063.04-.238.05-.479.056-.718.008-.336.003-.672 0-1.008-.002-.313-.019-.625-.035-.938.026.023.041.061.055.092.025.056.045.113.064.171a4.18 4.18 0 0 1 .148.6c.002.008.001.036.007.04l.077.068.178.157a.862.862 0 0 0 .401.218.97.97 0 0 0 .169.017l.332.01 1.27.036 1.123.032c.093.002.187.01.28-.003a.722.722 0 0 0 .62-.582c.061-.387-.243-.753-.655-.79Z"
                />
              </g>
            </g>
          </svg>
          <div class="delivery-method-texts">
            <span class="delivery-method-texts-description ods-typography-body-s-bold">
              {{ 'take_away_from_shop' | translate }}</span
            >
            <span class="delivery-method-texts-shop ods-typography-body-s-regular">{{ shopAddress }}</span>
          </div>
        </div>
      </ng-template>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="checkout-addresses-body">
    <p class="checkout-addresses-instructions">{{ 'choose_where_you_wantto_take_your_meal' | translate }}</p>
    <div class="checkout-addresses-container" *ngIf="addresses?.length">
      <address
        *ngFor="let address of addresses"
        class="hoverable checkout-address"
        [address]="address"
        (click)="onSelectAddress(address)"
      ></address>
    </div>
  </div>
  <div class="checkout-addresses-footer">
    <button
      box-button
      class="checkout-addresses-footer-btn"
      theme="secondary"
      type="button"
      (click)="onAddNewAddress()"
    >
      {{ 'add_new_address' | translate }}
    </button>
  </div>
</mat-expansion-panel>
